import { ValidationResult, ValidationRule, Value } from '@cnamts/vue-dot/src/rules/types';
import dayjs from 'dayjs';

/**
 * Check if value is a date between two given dates
 */
export function dateRange(
	min: string,
	max: string,
	format: string,
	messageMin = 'La date est trop loin dans le passé.',
	messageMax = 'La date est trop loin dans le futur.'
): ValidationRule {
	return (value: Value): ValidationResult => {
		const earliestDate = dayjs(min as string, format.toUpperCase())
			.set('second', 0)
			.set('minute', 0)
			.set('hour', 0);

		const latestDate = dayjs(max as string, format.toUpperCase())
			.set('second', 0)
			.set('minute', 0)
			.set('hour', 0);

		const valueDate = dayjs(value as string, format.toUpperCase())
			.set('second', 0)
			.set('minute', 0)
			.set('hour', 0);

		if (valueDate.isBefore(earliestDate)) {
			return messageMin;
		}

		if (valueDate.isAfter(latestDate)) {
			return messageMax;
		}

		return true;
	};
}

export default dateRange;
